import { stanleyCupChampions } from "data/stanleyCupData";
export const playerUtils = {
  getCorsWrappedUrl(url) {
    if (!url) return url;
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      return url;
    }
    if (url.includes(window.location.host)) {
      return url;
    }
    return `https://images.weserv.nl/?url=${encodeURIComponent(url)}`;
  },
  getPlayerHeadshot(playerId, team = null, season = null) {
    if (playerId === 8475166 && parseInt(season) === 2025) {
      return "/tavares.png";
    }
    if (playerId === 8484801 && parseInt(season) === 2025) {
      return "/celebrini-cupcake.png";
    }
    if (playerId === 8484227 && parseInt(season) === 2025) {
      return "/smith-cupcake.png";
    }
    if (playerId === 8481559 && parseInt(season) === 2025) {
      return "/hughes.png";
    }
    if (playerId === 8482175 && parseInt(season) === 2026) {
      return "/peterka.png";
    }
    if (playerId === 8471675 && parseInt(season) === 2009) {
      return "/crosby.png";
    }
    if (team && season) {
      const seasonYear = parseInt(season);
      const teamCode =
        team.toUpperCase() === "ARI" && seasonYear <= 2013
          ? "PHX"
          : team.toUpperCase();
      return `https://assets.nhle.com/mugs/nhl/${seasonYear}${seasonYear + 1}/${teamCode}/${playerId}.png`;
    }
    return `https://assets.nhle.com/mugs/nhl/latest/${playerId}.png`;
  },
  playerProfilePath(playerId, season = null) {
    return season == null
      ? `/players/v2/${playerId}`
      : `/players/v2/${playerId}?season=${season}`;
  },
  getDefaultHeadshot() {
    return "https://assets.nhle.com/mugs/nhl/default-skater.png";
  },
  getTeamColor(teamCode, season = null, actualTheme = "dark") {
    const retroColors = {
      NSH: [
        {
          start: 1998,
          end: 2010,
          primary: "#041E42",
          secondary: "#AFB7BA",
          worksOnDark: false,
        },
      ],
      BUF: [
        {
          start: 2006,
          end: 2019,
          primary: "#041E42",
          secondary: "#FFB81C",
          worksOnDark: false,
        },
      ],
      LAK: [
        {
          start: 1998,
          end: 2010,
          primary: "#250E62",
          secondary: "#A2AAAD",
          worksOnDark: false,
        },
      ],
      ANA: [
        {
          start: 2006,
          end: 2012,
          primary: "#000000",
          secondary: "#B5985A",
          worksOnDark: false,
        },
        {
          start: 2013,
          end: 2023,
          primary: "#000000",
          secondary: "#FC4C02",
          worksOnDark: false,
        },
      ],
      NYR: [
        {
          start: 2025,
          end: 2025,
          primary: "#0072CE",
          secondary: "#CE1126",
          worksOnDark: true,
        },
      ],
      DAL: [
        {
          start: 1994,
          end: 2012,
          primary: "#000000",
          secondary: "#C69214",
          worksOnDark: false,
        },
      ],
      PIT: [
        {
          start: 2006,
          end: 2015,
          primary: "#000000",
          secondary: "#C5B358",
          worksOnDark: false,
        },
      ],
      EDM: [
        {
          start: 1996,
          end: 2010,
          primary: "#041E42",
          secondary: "#AD7C59",
          worksOnDark: false,
        },
        {
          start: 2017,
          end: 2021,
          primary: "#FC4C02",
          secondary: "#041E42",
          worksOnDark: true,
        },
      ],
      FLA: [
        {
          start: 2003,
          end: 2010,
          primary: "#041E42",
          secondary: "#C8102E",
          worksOnDark: false,
        },
      ],
      STL: [
        {
          start: 1995,
          end: 2024,
          primary: "#002F87",
          secondary: "#FCB514",
          worksOnDark: false,
        },
      ],
      NYI: [
        {
          start: 1995,
          end: 2009,
          primary: "#041E42",
          secondary: "#FC4C02",
          worksOnDark: false,
        },
      ],
    };
    const teamBrand = {
      ANA: {
        primary: "#CF4520",
        secondary: "#000000",
        worksOnDark: true,
      },
      ARI: {
        primary: "#6F263D",
        secondary: "#862633",
        worksOnDark: false,
      },
      ATL: {
        primary: "#041E42",
        secondary: "#5C88DA",
        worksOnDark: false,
      },
      BOS: {
        primary: "#000000",
        secondary: "#FFB81C",
        worksOnDark: false,
      },
      BUF: {
        primary: "#003087",
        secondary: "#FFB81C",
        worksOnDark: false,
      },
      CGY: {
        primary: "#C8102E",
        secondary: "#F1BE48",
        worksOnDark: true,
      },
      CHI: {
        primary: "#CF0A2C",
        secondary: "#000000",
        worksOnDark: true,
      },
      CAR: {
        primary: "#CC0000",
        secondary: "#000000",
        worksOnDark: true,
      },
      COL: {
        primary: "#6F263D",
        secondary: "#236192",
        worksOnDark: true,
      },
      CBJ: {
        primary: "#002654",
        secondary: "#CE1126",
        worksOnDark: false,
      },
      DAL: {
        primary: "#006847",
        secondary: "#8F8F8C",
        worksOnDark: true,
      },
      DET: {
        primary: "#CE1126",
        secondary: "#FFFFFF",
        worksOnDark: true,
      },
      EDM: {
        primary: "#00205B",
        secondary: "#FF4C00",
        worksOnDark: false,
      },
      FLA: {
        primary: "#C8102E",
        secondary: "#041E42",
        worksOnDark: true,
      },
      LAK: {
        primary: "#000000",
        secondary: "#AFB7BA",
        worksOnDark: false,
      },
      MIN: {
        primary: "#154734",
        secondary: "#A6192E",
        worksOnDark: false,
      },
      MTL: {
        primary: "#AF1E2D",
        secondary: "#192168",
        worksOnDark: true,
      },
      NJD: {
        primary: "#CE1126",
        secondary: "#000000",
        worksOnDark: true,
      },
      NSH: {
        primary: "#efad1c",
        secondary: "#041E42",
        worksOnDark: true,
      },
      NYI: {
        primary: "#003087",
        secondary: "#FC4C02",
        worksOnDark: false,
      },
      NYR: {
        primary: "#0038A8",
        secondary: "#CE1126",
        worksOnDark: false,
      },
      OTT: {
        primary: "#C52032",
        secondary: "#D69F0F",
        worksOnDark: true,
      },
      PHI: {
        primary: "#F74902",
        secondary: "#000000",
        worksOnDark: true,
      },
      PIT: {
        primary: "#000000",
        secondary: "#ffb71cee",
        worksOnDark: false,
      },
      SEA: {
        primary: "#68A2B9",
        secondary: "#001628",
        worksOnDark: true,
      },
      SJS: {
        primary: "#006D75",
        secondary: "#000000",
        worksOnDark: true,
      },
      STL: {
        primary: "#0072CE",
        secondary: "#FCB514",
        worksOnDark: false,
      },
      TBL: {
        primary: "#002868",
        secondary: "#002c7e",
        worksOnDark: false,
      },
      TOR: {
        primary: "#00205B",
        secondary: "#002c7e",
        worksOnDark: false,
      },
      UTA: {
        primary: "#6CACE3",
        secondary: "#000000",
        worksOnDark: true,
      },
      VAN: {
        primary: "#00205B",
        secondary: "#00843D",
        worksOnDark: false,
      },
      VGK: {
        primary: "#B4975A",
        secondary: "#333F42",
        worksOnDark: true,
      },
      WSH: {
        primary: "#C8102E",
        secondary: "#041E42",
        worksOnDark: true,
      },
      WPG: {
        primary: "#041E42",
        secondary: "#0363C2",
        worksOnDark: false,
      },
    };
    let brand = teamBrand[teamCode];
    if (retroColors[teamCode] && season) {
      const seasonYear = parseInt(season);
      for (const era of retroColors[teamCode]) {
        if (seasonYear >= era.start && seasonYear <= era.end) {
          brand = {
            ...brand,
            ...era,
          };
          break;
        }
      }
    }
    if (!brand) return "#AFB7BA";
    if (actualTheme === "light") {
      return brand.primary;
    }
    if (brand.worksOnDark) {
      return brand.primary;
    }
    if (
      brand.secondary &&
      brand.secondary !== "#FFFFFF" &&
      brand.secondary !== "#000000"
    ) {
      return brand.secondary;
    }
    return brand.primary;
  },
  getSurfaceGradient(color, actualTheme = "dark") {
    if (!color) return color;
    const topShade =
      actualTheme === "light"
        ? "rgba(7, 12, 20, 0.22)"
        : "rgba(3, 7, 14, 0.42)";
    const midShade =
      actualTheme === "light"
        ? "rgba(7, 12, 20, 0.08)"
        : "rgba(3, 7, 14, 0.14)";
    const bottomLift =
      actualTheme === "light"
        ? "rgba(255, 255, 255, 0.1)"
        : "rgba(255, 255, 255, 0.12)";
    return `linear-gradient(180deg, ${topShade} 0%, ${midShade} 38%, rgba(255, 255, 255, 0.02) 72%, ${bottomLift} 100%), linear-gradient(180deg, ${color} 0%, ${color} 100%)`;
  },
  toRgba(color, alpha = 1) {
    if (typeof color !== "string" || !color.startsWith("#")) return color;
    let hex = color.slice(1);
    if (hex.length === 3 || hex.length === 4) {
      hex = hex
        .split("")
        .map((char) => char + char)
        .join("");
    }
    let baseAlpha = 1;
    if (hex.length === 8) {
      baseAlpha = parseInt(hex.slice(6, 8), 16) / 255;
      hex = hex.slice(0, 6);
    }
    if (hex.length !== 6) return color;
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    const finalAlpha = Math.max(0, Math.min(1, alpha * baseAlpha));
    return `rgba(${r}, ${g}, ${b}, ${finalAlpha})`;
  },
  getCardGradient(color, actualTheme = "dark") {
    if (!color) return color;
    const topTint = this.toRgba(color, actualTheme === "light" ? 0.2 : 0.26);
    const upperTint = this.toRgba(color, actualTheme === "light" ? 0.11 : 0.14);
    const lowerTint = this.toRgba(color, actualTheme === "light" ? 0.04 : 0.05);
    const transparentTint = this.toRgba(color, 0);
    return `linear-gradient(180deg, ${topTint} 0%, ${upperTint} 18%, ${lowerTint} 32%, ${transparentTint} 54%, ${transparentTint} 100%)`;
  },
  getTeamColorGradient(teamCode, season = null, actualTheme = "dark") {
    return this.getSurfaceGradient(
      this.getTeamColor(teamCode, season, actualTheme),
      actualTheme
    );
  },
  getTeamCardGradient(teamCode, season = null, actualTheme = "dark") {
    return this.getCardGradient(
      this.getTeamColor(teamCode, season, actualTheme),
      actualTheme
    );
  },
  getFullTeamName(teamCode, season = null) {
    if (teamCode.toUpperCase() === "ARI" && season <= 2013) {
      return "Phoenix Coyotes";
    }
    if (teamCode.toUpperCase() === "UTA" && season < 2025) {
      return "Utah Hockey Club";
    }
    const teamNames = {
      ANA: "Anaheim Ducks",
      ARI: "Arizona Coyotes",
      ATL: "Atlanta Thrashers",
      BOS: "Boston Bruins",
      BUF: "Buffalo Sabres",
      CGY: "Calgary Flames",
      CHI: "Chicago Blackhawks",
      CAR: "Carolina Hurricanes",
      COL: "Colorado Avalanche",
      CBJ: "Columbus Blue Jackets",
      DAL: "Dallas Stars",
      DET: "Detroit Red Wings",
      EDM: "Edmonton Oilers",
      FLA: "Florida Panthers",
      LAK: "Los Angeles Kings",
      MIN: "Minnesota Wild",
      MTL: "Montreal Canadiens",
      NJD: "New Jersey Devils",
      NSH: "Nashville Predators",
      NYI: "New York Islanders",
      NYR: "New York Rangers",
      OTT: "Ottawa Senators",
      PHI: "Philadelphia Flyers",
      PIT: "Pittsburgh Penguins",
      SEA: "Seattle Kraken",
      SJS: "San Jose Sharks",
      STL: "St. Louis Blues",
      TBL: "Tampa Bay Lightning",
      TOR: "Toronto Maple Leafs",
      UTA: "Utah Mammoth",
      VAN: "Vancouver Canucks",
      VGK: "Vegas Golden Knights",
      WSH: "Washington Capitals",
      WPG: "Winnipeg Jets",
    };
    return teamNames[teamCode.toUpperCase()] || teamCode.toUpperCase();
  },
  getTeamLogoUrl(teamCode, season = null, actualTheme = "dark") {
    if (!teamCode) return null;
    const suffix = actualTheme === "light" ? "light" : "dark";
    const applySuffix = (path) =>
      path.replace(/_(?:dark)\.svg$/i, `_${suffix}.svg`);
    const base = "https://assets.nhle.com/logos/nhl/svg";
    const teamCodeUpper = teamCode.toUpperCase();
    if (teamCodeUpper === "WSH") {
      return `${base}/${applySuffix("WSH_secondary_dark.svg")}`;
    }
    if (!season) {
      if (teamCodeUpper === "ATL") {
        return `${base}/${applySuffix("ATL_19992000-20102011_dark.svg")}`;
      }
      if (teamCodeUpper === "PHX") {
        return `${base}/${applySuffix("PHX_20032004-20132014_dark.svg")}`;
      }
      return `${base}/${teamCodeUpper}_${suffix}.svg`;
    }
    const seasonYear = parseInt(season);
    if (teamCodeUpper === "TOR" && seasonYear == 2016) {
      return "/leafs-100.svg";
    }
    if (teamCodeUpper === "MTL" && (seasonYear == 2008 || seasonYear == 2009)) {
      return "/canadiens-100-1.svg";
    }
    if (teamCodeUpper === "BOS" && seasonYear == 2023) {
      return "/bruins-100.svg";
    }
    if (seasonYear === 2025) {
      if (teamCodeUpper === "NYR") return "/rangers-100.svg";
      else if (teamCodeUpper === "DET") return "/redwings-100.svg";
      else if (teamCodeUpper === "CHI")
        return actualTheme == "dark"
          ? "/blackhawks-100-dark.svg"
          : "/blackhawks-100.svg";
    }
    if (teamCodeUpper === "NSH" && seasonYear >= 1998 && seasonYear <= 2010) {
      return actualTheme === "dark"
        ? `${base}/NSH_19981999-20102011_light.svg`
        : `${base}/NSH_19981999-20102011_dark.svg`;
    }
    const logoEras = {
      ATL: [
        {
          start: 1999,
          end: 2010,
          url: "ATL_19992000-20102011_dark.svg",
        },
      ],
      ARI: [
        {
          start: 2003,
          end: 2020,
          url: "PHX_20032004-20132014_dark.svg",
        },
      ],
      BUF: [
        {
          start: 2006,
          end: 2009,
          url: "BUF_20062007-20092010_dark.svg",
        },
        {
          start: 2010,
          end: 2019,
          url: "BUF_20102011-20192020_dark.svg",
        },
      ],
      CGY: [
        {
          start: 1994,
          end: 2019,
          url: "CGY_19941995-20192020_dark.svg",
        },
      ],
      CHI: [
        {
          start: 2025,
          end: 2025,
          url: "CHI_19651966-19881989_dark.svg",
        },
      ],
      DET: [
        {
          start: 2025,
          end: 2025,
          url: "DET_19321933-19471948_dark.svg",
        },
      ],
      EDM: [
        {
          start: 1996,
          end: 2010,
          url: "EDM_19971998-20102011_dark.svg",
        },
        {
          start: 2017,
          end: 2021,
          url: "EDM_20172018-20212022_dark.svg",
        },
      ],
      NYI: [
        {
          start: 1997,
          end: 2009,
          url: "NYI_19971998-20092010_dark.svg",
        },
      ],
      OTT: [
        {
          start: 2007,
          end: 2019,
          url: "OTT_20072008-20192020_dark.svg",
        },
      ],
      TBL: [
        {
          start: 2008,
          end: 2010,
          url: "TBL_20072008-20102011_dark.svg",
        },
      ],
      ANA: [
        {
          start: 2006,
          end: 2023,
          url: "ANA_20132014-20232024_dark.svg",
        },
      ],
      DAL: [
        {
          start: 1994,
          end: 2012,
          url: "DAL_19941995-20122013_dark.svg",
        },
      ],
      FLA: [
        {
          start: 1999,
          end: 2015,
          url: "FLA_19992000-20152016_dark.svg",
        },
      ],
      MTL: [
        {
          start: 2009,
          end: 2010,
          url: "MTL_19171918-19181919_dark.svg",
        },
      ],
      NYR: [
        {
          start: 2025,
          end: 2025,
          url: "NYR_19261927-19341935_dark.svg",
        },
      ],
      PIT: [
        {
          start: 2006,
          end: 2015,
          url: "PIT_20062007-20152016_dark.svg",
        },
      ],
      LAK: [
        {
          start: 2002,
          end: 2009,
          url: "LAK_20022003-20092010_dark.svg",
        },
        {
          start: 2010,
          end: 2010,
          url: "LAK_20102011_dark.svg",
        },
        {
          start: 2011,
          end: 2018,
          url: "LAK_20112012-20182019_dark.svg",
        },
        {
          start: 2019,
          end: 2023,
          url: "LAK_20192020-20232024_dark.svg",
        },
      ],
      BOS: [
        {
          start: 2008,
          end: 2022,
          url: "BOS_20082009-20222023_dark.svg",
        },
        {
          start: 2024,
          end: 2024,
          url: "BOS_20082009-20222023_dark.svg",
        },
      ],
      TOR: [
        {
          start: 1987,
          end: 2015,
          url: "TOR_19871988-20152016_dark.svg",
        },
      ],
      STL: [
        {
          start: 2008,
          end: 2024,
          url: "STL_20082009-20242025_light.svg",
        },
      ],
      UTA: [
        {
          start: 2024,
          end: 2024,
          url: "UTA_20242025-20242025_dark.svg",
        },
      ],
    };
    if (logoEras[teamCodeUpper]) {
      for (const era of logoEras[teamCodeUpper]) {
        if (seasonYear >= era.start && seasonYear <= era.end) {
          return `${base}/${applySuffix(era.url)}`;
        }
      }
    }
    if (
      teamCodeUpper === "CGY" &&
      seasonYear >= 2020 &&
      actualTheme === "dark"
    ) {
      return `${base}/CGY_hdr_dark.svg`;
    }
    return `${base}/${teamCodeUpper}_${suffix}.svg`;
  },
  didWinStanleyCup(team, season) {
    const seasonYear = parseInt(season);
    const teamCode = String(team || "")
      .trim()
      .toUpperCase();
    return stanleyCupChampions[seasonYear] === teamCode;
  },
  isCurrentSeason(season, currentSeason) {
    return currentSeason != null && Number(season) === Number(currentSeason);
  },
  formatSeasonLabel(season, currentSeason) {
    return this.isCurrentSeason(season, currentSeason)
      ? "Current"
      : this.formatSeason(season);
  },
  formatCombinedSeasons(combined) {
    return combined.seasons
      .map((season) => this.formatSeason(season))
      .join(" + ");
  },
  formatCareerSpan(firstSeason, lastSeason) {
    if (firstSeason === lastSeason) return this.formatSeason(firstSeason);
    return `${firstSeason}–${Number(lastSeason) + 1}`;
  },
  formatSeason(year) {
    const yearNum = parseInt(year);
    if (isNaN(yearNum)) return year;
    const nextYear = yearNum + 1;
    return `${yearNum}-${nextYear}`;
  },
  formatStatName(statKey) {
    const statNames = {
      SHOT_TAL: "Finishing",
      PLAY_DRV: "Chance Creation",
      SHOT_FREQ: "Shooting Tendency",
      PASS_FREQ: "Offensive Buildup",
      PP_USAGE: "Positioning",
      ONICE_IMP: "5-on-5 Game Score Impact",
      POS_CTRL: "Defensive Impact",
      BLK: "Shot Blocking",
      HIT: "Physical Engagement",
      PHYS: "Physical Pressure",
      TAKE: "Takeaways",
      CH_SUP: "Chance Suppression",
      D_EXIT: "D-Zone Exits",
      GOAL_PREV: "Goal Prevention",
      SV_PCT: "Save Percentage",
      GSAX: "Goals Saved Above Expected (GSAX/60)",
      HD_SV: "High-Danger Save %",
      MD_SV: "Medium-Danger Save %",
      LD_SV: "Low-Danger Save %",
      GA_60: "Goals Against / 60",
      WORKLOAD: "Shots Faced / 60",
      xGA_60: "Expected Goals Against / 60",
      REB_CTRL: "Rebound Control",
      FREEZE: "Puck Freeze Rate",
      HD_WORK: "High-Danger Shots Faced / 60",
      GAMES: "Games Played",
      TOP_SPEED: "Top Skating Speed",
      SPEED_BURSTS: "Speed Bursts (20+ mph)",
      SHOT_SPEED: "Top Shot Speed",
      DIST_SKATED: "Distance Skated",
      DIST_GAME: "Max Game Distance",
      OZONE: "Offensive Zone Time",
      EDGE_HIGH_SV: "NHL EDGE Short-Range Save %",
      EDGE_MID_SV: "NHL EDGE Mid-Range Save %",
      EDGE_LONG_SV: "NHL EDGE Long-Range Save %",
    };
    return statNames[statKey] || statKey;
  },
  formatStatAbbr(statKey) {
    const statAbbrs = {
      SHOT_TAL: "Finish",
      PLAY_DRV: "Create",
      SHOT_FREQ: "Shot Tnd",
      PASS_FREQ: "Buildup",
      PP_USAGE: "Position",
      ONICE_IMP: "Impact",
      POS_CTRL: "Def Imp",
      BLK: "Blk",
      HIT: "Hit",
      PHYS: "Phys",
      TAKE: "Take",
      CH_SUP: "Ch Sup",
      D_EXIT: "DZ Exits",
      GOAL_PREV: "Goal Prv",
      SV_PCT: "SV%",
      GSAX: "GSAx",
      HD_SV: "HD SV%",
      MD_SV: "MD SV%",
      LD_SV: "LD SV%",
      GA_60: "GA/60",
      WORKLOAD: "SF/60",
      xGA_60: "xGA/60",
      REB_CTRL: "Reb Ctrl",
      FREEZE: "Frz%",
      HD_WORK: "HDSF/60",
      GAMES: "GP",
      TOP_SPEED: "Top Spd",
      SPEED_BURSTS: "20+ mph",
      SHOT_SPEED: "Shot Spd",
      DIST_SKATED: "Distance",
      DIST_GAME: "Game Dist",
      OZONE: "OZ Time",
      EDGE_HIGH_SV: "Short SV%",
      EDGE_MID_SV: "Mid SV%",
      EDGE_LONG_SV: "Long SV%",
    };
    return statAbbrs[statKey] || this.formatStatName(statKey);
  },
  getStatExplanation(statKey) {
    const explanations = {
      SHOT_TAL:
        "How efficiently the player converts chances compared with players at the same position.",
      PLAY_DRV:
        "How effectively the player creates scoring chances for themselves and teammates.",
      SHOT_FREQ: "How often the player chooses to shoot the puck.",
      PASS_FREQ:
        "Playmaking and team-offense involvement compared with positional peers.",
      PP_USAGE:
        "How consistently the player reaches dangerous offensive locations.",
      ONICE_IMP:
        "The player's 5-on-5 Game Score rate compared with positional peers.",
      POS_CTRL:
        "Role-aware defensive quality across takeaways, chance suppression, and goal prevention.",
      BLK: "Share of opponent shot attempts the player blocks while on the ice at 5-on-5, so players who face fewer shots aren't penalized.",
      HIT: "How often the player uses physical contact (hits, scrums, or fights) to disrupt opponents.",
      PHYS: "Hits and takeaways per 60 minutes the opponent has the puck at 5-on-5 (ice time × (1 − Corsi %)), plus penalties drawn per 60, so players on puck-dominant teams aren't penalized for fewer chances to hit.",
      TAKE: "How often the player takes the puck away from opponents.",
      CH_SUP: "Share of opponent scoring chances limited by the player.",
      D_EXIT:
        "How reliably the team gets the puck out of its own end with the player on the ice, from zone transitions across his shifts and how rarely he gives the puck away in the defensive zone.",
      GOAL_PREV: "Share of scoring attempts stopped by the player.",
      winShare:
        "The percentile rank of the player's contribution to team wins compared to other players on the team in the same position.",
      SV_PCT:
        "Ranks the goalie's overall save percentage vs. other goaltenders.",
      GSAX: "Goals saved above expected per 60 minutes. Measures a goalie's shot-stopping impact relative to the quality of shots faced.",
      HD_SV: "Save percentage on high-danger shots (from the slot/inner slot).",
      MD_SV: "Save percentage on medium-danger shots.",
      LD_SV: "Save percentage on low-danger shots (from distance/poor angles).",
      GA_60:
        "Goals against per 60 minutes, inverted so fewer goals against is a higher rank.",
      WORKLOAD: "Shots faced per 60 minutes. Measures how busy the goalie is.",
      xGA_60:
        "Expected goals against per 60 minutes. Reflects the difficulty of shots faced.",
      REB_CTRL:
        "Rebound control, based on the share of shots faced that became a rebound (rebounds ÷ shots on goal, with goals allowed in the denominator). Inverted so fewer rebounds allowed is higher.",
      FREEZE:
        "Share of shots faced that the goalie froze to stop play (freezes ÷ shots on goal, with goals allowed in the denominator). A volume-independent rate rather than a raw count.",
      HD_WORK: "High-danger shots faced per 60 minutes.",
      GAMES: "Total games played in the season.",
      TOP_SPEED:
        "Fastest skating speed reached during the season (mph), tracked by NHL Edge.",
      SPEED_BURSTS:
        "Number of skating bursts over 20 mph, tracked by NHL Edge.",
      SHOT_SPEED:
        "Hardest shot speed recorded during the season (mph), tracked by NHL Edge.",
      DIST_SKATED:
        "Total distance skated over the season (miles), tracked by NHL Edge.",
      DIST_GAME:
        "Most distance skated in a single game (miles), tracked by NHL Edge.",
      OZONE:
        "Share of on-ice time spent in the offensive zone, tracked by NHL Edge.",
    };
    return (
      explanations[statKey] ||
      "Player performance metric compared to league average."
    );
  },
  getTopStats(stats, count = 6) {
    return Object.entries(stats)
      .sort(([, a], [, b]) => b - a)
      .slice(0, count)
      .map(([key, value]) => ({
        key,
        name: this.formatStatName(key),
        value,
      }));
  },
  getOffensiveStats(stats, allPercentiles = null) {
    const statKeys = [
      "I_F_goals",
      "I_F_xGoals",
      "I_F_primaryAssists",
      "I_F_points",
      "OnIce_F_xGoals",
      "I_F_giveaways",
    ];
    return statKeys
      .map((key) => {
        let value = stats[key];
        if (value === undefined && allPercentiles) {
          if (
            allPercentiles.offensive &&
            allPercentiles.offensive[key] !== undefined
          ) {
            value = allPercentiles.offensive[key];
          } else if (
            allPercentiles.defensive &&
            allPercentiles.defensive[key] !== undefined
          ) {
            value = allPercentiles.defensive[key];
          } else if (allPercentiles[key] !== undefined) {
            value = allPercentiles[key];
          }
        }
        if (value !== undefined) {
          return {
            key,
            name: this.formatStatName(key),
            value: value,
          };
        }
        return null;
      })
      .filter((stat) => stat !== null);
  },
};
